// Copyright (c) 2021, DIALPAD INC., all rights reserved.

import React from 'react';
import {Link} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {Button, Spinner} from '@app/common';
import {MdComputer, MdPhone} from 'react-icons/md';
import moment from 'moment';
import {areAspectFeedbackMessagesFetchingSelector} from '@app/redux/feedback/selectors';

/* Displays the information of the current selected feedback message.
 */
export const FeedbackViewer = (props) => {
    const {selectedMessage} = props;
    const isRefreshing = useSelector((state) =>
        areAspectFeedbackMessagesFetchingSelector(state),
    );
    const isUser = selectedMessage ? !!selectedMessage.user_id : false;
    const renderSpinner = () => {
        return (
            <div className="feedback-spinner">
                <Spinner />
            </div>
        );
    };

    return selectedMessage && !isRefreshing ? (
        <div className="viewer">
            <div className="viewer-header">
                <div className="feedback-details">
                    <div className="user">
                        <span className="icon">
                            <MdComputer size={16} />
                        </span>
                        <span className="name">
                            {isUser ? selectedMessage.user_id : 'VISITOR'}
                        </span>
                    </div>
                    {isUser && (
                        <div className="contact">
                            <span className="icon">
                                <MdPhone size={16} />
                            </span>

                            <span className="number">
                                {selectedMessage.user_tags}
                            </span>
                        </div>
                    )}
                    <div className="date">
                        {moment
                            .unix(selectedMessage.created_at)
                            .format('DD/MM/YYYY • HH:mm')}
                    </div>
                </div>
                <div className="conversation-button">
                    <Link
                        to={`/activity/conversations?id=${selectedMessage.conversation_id}`}
                    >
                        <Button className="feedback__button" outlined>
                            VIEW CONVERSATION
                        </Button>
                    </Link>
                </div>
            </div>
            <div className="viewer-body">
                <span>{selectedMessage.body.feedback}</span>
            </div>
        </div>
    ) : (
        renderSpinner()
    );
};
